/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_S1_LinkInputs */

const en_mk_ctrl_s1_link = /** @type {(inputs: Mk_Ctrl_S1_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check a repo for free`)
};

const id_mk_ctrl_s1_link = /** @type {(inputs: Mk_Ctrl_S1_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cek repo gratis`)
};

/**
* | output |
* | --- |
* | "Check a repo for free" |
*
* @param {Mk_Ctrl_S1_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_s1_link = /** @type {((inputs?: Mk_Ctrl_S1_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_S1_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_s1_link(inputs)
	return en_mk_ctrl_s1_link(inputs)
});